import type { CopilotArtifact } from '../../CopilotContext';

import { ComparisonTable } from './ComparisonTable';
import { MeasurementPlot } from './MeasurementPlot';
import { QualityIssues } from './QualityIssues';

/** Renders the analysis artifacts a turn produced, inline under its bubble. */
export function MessageArtifacts({
  artifacts,
}: {
  artifacts: CopilotArtifact[];
}) {
  return (
    <>
      {artifacts.map((artifact) => {
        switch (artifact.kind) {
          case 'plot':
            return (
              <MeasurementPlot
                key={`plot-${artifact.kind}`}
                data={artifact.data}
              />
            );
          case 'comparison':
            return (
              <ComparisonTable
                key={`comp-${artifact.kind}`}
                data={artifact.data}
              />
            );
          case 'quality':
            return (
              <QualityIssues
                key={`qual-${artifact.kind}`}
                data={artifact.data}
              />
            );
          default:
            return null;
        }
      })}
    </>
  );
}
